let sessionSnapshot = {user: null, status: 'loading'}

export const getSessionSnapshot = () => sessionSnapshot
export const sessionState = {
    defaultState: {
        sessionUser: null,
        sessionStatus: 'loading',
    },
    actions: {
        setSessionUser: (user, state) => {
            sessionSnapshot = {user: user || null, status: user ? 'authenticated' : 'guest'}
            return {...state, sessionUser: sessionSnapshot.user, sessionStatus: sessionSnapshot.status}
        },
        setSessionError: (_, state) => {
            sessionSnapshot = {user: null, status: 'error'}
            return {...state, sessionUser: null, sessionStatus: 'error'}
        },
    },
}
